<template>
  <section class="online-white-ui">
    <div class="page-title-row">
      <h3>회원관리 <span>»</span> 접속자 목록</h3>
    </div>

    <div class="searchwrap online-searchwrap">
      <div class="search-main">
        <div class="search-line">
          <div class="search-group date-group">
            <label>날짜</label>
            <input type="date" :value="dateOnly(startDate)" @change="setStartDateInput" />
            <span class="date-wave">~</span>
            <input type="date" :value="dateOnly(endDate)" @change="setEndDateInput" />
            <button type="button" class="quick-btn active" @click="setDateQuick('today')">오늘</button>
            <button type="button" class="quick-btn" @click="setDateQuick('prevWeek')">이번 주</button>
            <button type="button" class="quick-btn" @click="setDateQuick('lastWeek')">지난 주</button>
            <button type="button" class="quick-btn" @click="setDateQuick('thisMonth')">이번 달</button>
            <button type="button" class="quick-btn" @click="setDateQuick('lastMonth')">지난 달</button>
          </div>

          <div class="search-group sort-group">
            <label>정렬옵션</label>
            <select v-model="userListOrder">
              <option value="JOIN_DESC">생성순</option>
              <option value="ID_ASC">아이디 순</option>
              <option value="CASH_DESC">보유머니 순</option>
              <option value="ROLLING_DESC">보유롤링금 순</option>
            </select>
          </div>
        </div>
        <div class="search-line">
          <div class="search-group category-group">
            <label>카테고리</label>
            <input type="text" v-model="searchValue" placeholder="회원아이디" @keyup.enter="searchOnlineUsers" />
            <button class="btn-search" type="button" data-api="search-online-user" @click="searchOnlineUsers">
              검색
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-contents-wrapper">
      <article class="total-info-container">
        <div class="total-info-wrap">
          <div class="total-info-item">
            <i class="fas fa-search"></i>
            <span>검색결과</span>
          </div>
          <div class="total-info-item">
            <span class="title">전체</span> :
            <span class="value">{{ numberWithCommas(totalCount) }}</span>
          </div>
        </div>
      </article>

      <div class="online-content-grid">
        <div class="table-wrapper online-table-card">
          <table class="mainTable online-main-table">
            <colgroup>
              <col style="width: 6%;" />
              <col style="width: 10%;" />
              <col style="width: 9%;" />
              <col style="width: 9%;" />
              <col style="width: 9%;" />
              <col style="width: 12%;" />
              <col style="width: 10%;" />
              <col style="width: 7%;" />
              <col style="width: 10%;" />
              <col style="width: 7%;" />
              <col style="width: 11%;" />
              <col style="width: 5%;" />
              <col style="width: 5%;" />
            </colgroup>
            <thead>
              <tr>
                <th>번호</th>
                <th>아이디<br />닉네임</th>
                <th>상부</th>
                <th>보유머니</th>
                <th>보유포인트</th>
                <th>{{ $t('front.common.inTotal') }} / {{ $t('front.cash.exchange') }}</th>
                <th>유지시간<br />접속IP</th>
                <th>입/출금액</th>
                <th>입출손익</th>
                <th>베팅금액<br />당첨금액</th>
                <th>베팅손익</th>
                <th>최근실행게임<br />게임명</th>
                <th>이동</th>
                <th>강제<br />로그아웃</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="pagedUserList && pagedUserList.length > 0">
                <tr v-for="(item, idx) in pagedUserList" :key="item.memId || idx">
                  <td class="roboto">{{ getRowNumber(idx) }}</td>
                  <td>
                    <div class="id-cell">
                      <button type="button" class="fc-id btn-link" @click="openUserDetail(item.memId)">{{ blank(item.memId) }}</button>
                      <button type="button" class="fc-nick btn-link" @click="openUserDetail(item.memId)">
                        <span class="box">{{ blank(item.memNick) }}</span>
                      </button>
                    </div>
                  </td>
                  <td>
                    <div class="topwrap" v-if="Array.isArray(item.topUserList) && item.topUserList.length > 0">
                      <select class="upperUser" @focus="loadTopUserList(item)" @mousedown="loadTopUserList(item)">
                        <option v-for="pt in item.topUserList.slice(0, 1)" :key="`${item.memId}_${pt.recommenderId}_${pt.partnerLevel || ''}`">
                          [{{ blank(pt.partnerLevelName) }}] {{ blank(pt.recommenderId) }}
                        </option>
                      </select>
                      <i class="icon">+</i>
                    </div>
                    <div v-else>-</div>
                  </td>
                  <td class="roboto strong-money">{{ numberWithCommas(item.cashAmt) }}</td>
                  <td class="roboto strong-money">{{ numberWithCommas(item.pointAmt) }}</td>
                  <td>
                    <div class="btn-input-wrap">
                      <a class="inout-btn btn-green" @click="onOpenPay(item, idx)">{{ $t('front.give.give') }}/{{ $t('front.give.back') }}</a>
                    </div>
                  </td>
                  <td>
                    <div class="ipwrap roboto">
                      <span>{{ blank(item.loginDt) }}</span>
                      <span class="ip">{{ blank(item.loginIP) }}</span>
                    </div>
                  </td>
                  <td>
                    <ul class="money">
                      <li><em>총 입금액 :</em><span>{{ numberWithCommas(item.cashIn) }}</span></li>
                      <li><em>총 출금액 :</em><span>{{ numberWithCommas(item.cashOut) }}</span></li>
                    </ul>
                  </td>
                  <td :class="profitClass(item.cashIn, item.cashOut)" class="roboto">
                    {{ numberWithCommas(toNumber(item.cashIn) - toNumber(item.cashOut)) }}
                  </td>
                  <td>
                    <ul class="money">
                      <li><em>베팅금액 :</em><span>{{ numberWithCommas(getBetAmt(item)) }}</span></li>
                      <li><em>당첨금액 :</em><span>{{ numberWithCommas(getWinAmt(item)) }}</span></li>
                    </ul>
                  </td>
                  <td :class="profitClass(getBetAmt(item), getWinAmt(item))" class="roboto">
                    {{ numberWithCommas(getBetWinLose(item)) }}
                  </td>
                  <td>
                    <div class="recent-game" v-html="formatData(item.betData)"></div>
                  </td>
                  <td>
                    <div class="status-change-btn-wrap">
                      <button type="button" class="btn-inout" data-api="bet-list" :data-mem-id="item.memId || ''" @click="goToBetDetail(item.memId)">베팅<br />내역</button>
                    </div>
                  </td>
                  <td>
                    <div class="status-change-btn-wrap">
                      <button type="button" class="btn-inout bg-rd" data-api="force-logout" :data-mem-id="item.memId || ''" @click="forceLogout(item.memId)">로그<br />아웃</button>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="13" class="empty-cell">데이터가 없습니다.</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <pagination
      v-if="pageInfo && Number(pageInfo.tatal_list_count || 0) > 0"
      :pageNum="pageInfo.page || 1"
      :pageSize="pageInfo.count_per_list || 40"
      :totalCount="pageInfo.tatal_list_count || 0"
      :className="'partnerPaging'"
      @goToPage="goToPage"
    />

    <transition name="fade">
      <Paymodal v-if="PayMopen" :selectMem="selectMem" :selectIdx="selectIdx" @close="onClosePay" />
    </transition>
  </section>
</template>

<script>
import Pagination from '@/components/ui/Pagination.vue'
import { getDateStr, thousand, replaceDateT } from '@/libs/utils'
import { addDays, startOfMonth, endOfMonth, subMonths } from 'date-fns'
import { getUserOnlineListV2, getTopUserListV2, memLogoutV2 } from '@/api/v2/user'
import Paymodal from '@/components/common/Pay.vue'

export default {
  name: 'partnerUserList',
  components: { Paymodal, Pagination },
  computed: {
    totalCount () {
      if (this.pageInfo && this.pageInfo.tatal_list_count !== undefined && this.pageInfo.tatal_list_count !== null) {
        return this.pageInfo.tatal_list_count
      }
      return this.userList ? this.userList.length : 0
    },
    sortedUserList () {
      const list = Array.isArray(this.userList) ? [...this.userList] : []
      if (this.userListOrder === 'ID_ASC') {
        return list.sort((a, b) => String(a.memId || '').localeCompare(String(b.memId || '')))
      }
      if (this.userListOrder === 'CASH_DESC') {
        return list.sort((a, b) => this.toNumber(b.cashAmt) - this.toNumber(a.cashAmt))
      }
      return list
    },
    pagedUserList () {
      const page = this.pageInfo.page || 1
      const pageSize = this.pageInfo.count_per_list || 40
      const start = (page - 1) * pageSize
      return this.sortedUserList.slice(start, start + pageSize)
    }
  },
  data () {
    return {
      userList: [],
      userListOrder: 'JOIN_DESC',
      searchValue: '',
      startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
      endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59'),
      refreshInterval: null,
      pageInfo: {
        page: 1,
        count_per_list: 40,
        tatal_list_count: 0
      },
      PayMopen: false,
      selectMem: null,
      selectIdx: null
    }
  },
  async created () {
    await this.loadSubList('', 'main', 1)

    this.refreshInterval = setInterval(() => {
      this.loadSubList('', 'sub', this.pageInfo.page || 1)
    }, 60000)
  },
  beforeUnmount () {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  watch: {
    userListOrder () {
      this.pageInfo.page = 1
    }
  },
  methods: {
    thousand,
    onClosePay (newCash, idx) {
      if (newCash !== null && newCash !== undefined) {
        this.pagedUserList[idx].cashAmt = newCash
      }
      this.PayMopen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onOpenPay (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.PayMopen = true
    },
    setLoading (yn) {
      if (this.emitter && this.emitter.emit) {
        this.emitter.emit('Loading', yn)
      }
    },
    blank (value) {
      if (value === null || value === undefined || value === '') return ''
      return value
    },
    toNumber (value) {
      if (value === null || value === undefined || value === '') return 0
      const parsed = Number(String(value).replace(/,/g, ''))
      return Number.isNaN(parsed) ? 0 : parsed
    },
    numberWithCommas (value) {
      if (value === null || value === undefined || value === '') return ''
      return thousand(this.toNumber(value))
    },
    onTodoButton (name) {
      console.log(`${name} API 연동 예정`)
    },
    dateOnly (value) {
      if (!value) return ''
      return value.toString().substring(0, 10)
    },
    setStartDateInput (e) {
      this.startDate = `${e.target.value} 00:00:00`
      this.searchOnlineUsers()
    },
    setEndDateInput (e) {
      this.endDate = `${e.target.value} 23:59:59`
      this.searchOnlineUsers()
    },
    setDateQuick (type) {
      const today = new Date()
      let start = today
      let end = today

      if (type === 'prevWeek') {
        start = addDays(today, -7)
      } else if (type === 'lastWeek') {
        start = addDays(today, -14)
        end = addDays(today, -7)
      } else if (type === 'thisMonth') {
        start = startOfMonth(today)
        end = endOfMonth(today)
      } else if (type === 'lastMonth') {
        const lastMonth = subMonths(today, 1)
        start = startOfMonth(lastMonth)
        end = endOfMonth(lastMonth)
      }

      this.startDate = getDateStr(start, 'yyyy-MM-dd 00:00:00')
      this.endDate = getDateStr(end, 'yyyy-MM-dd 23:59:59')
      this.searchOnlineUsers()
    },
    getRowNumber (idx) {
      const page = this.pageInfo.page || 1
      const pageSize = this.pageInfo.count_per_list || 40
      return (page - 1) * pageSize + idx + 1
    },
    openUserDetail (memId) {
      if (!memId) return
      if (this.detailOpen) {
        this.detailOpen('user', memId)
      }
    },
    goToBetDetail (memId) {
      if (!memId) return
      const route = this.$router.resolve({
        name: 'bettingDetailListCasino',
        query: {
          id: memId
        }
      })
      window.open(route.href, '_blank')
    },
    goToPage (page) {
      this.pageInfo.page = page || 1
    },
    searchOnlineUsers () {
      this.loadSubList('', 'search', 1)
    },
    async forceLogout (memId) {
      if (!memId) return

      const confirm = await this.onConfirm(`'${memId}' 아이디를 강제 로그아웃 시키겠습니까?`)
      if (!confirm) return

      this.setLoading(true)
      try {
        const res = await memLogoutV2({ memId })
        const result = res.data || {}
        this.setLoading(false)

        if (result.resultCode === '0') {
          await this.loadSubList('', 'force-logout', this.pageInfo.page || 1)
          await this.onCheck('강제 로그아웃 처리되었습니다.')
          return
        }

        await this.onAlert('warningart', result.resultMessage || '강제 로그아웃 처리에 실패했습니다.')
      } catch (e) {
        console.error(e)
        this.setLoading(false)
        await this.onAlert('warningart', '강제 로그아웃 처리에 실패했습니다.')
      }
    },
    getBetAmt (item) {
      return item.betAmt !== undefined && item.betAmt !== null ? item.betAmt : item.casinoBetAmt
    },
    getWinAmt (item) {
      return item.winAmt !== undefined && item.winAmt !== null ? item.winAmt : item.casinoWinAmt
    },
    getBetWinLose (item) {
      if (item.winLose !== undefined && item.winLose !== null && item.winLose !== '') {
        return item.winLose
      }
      return this.toNumber(this.getBetAmt(item)) - this.toNumber(this.getWinAmt(item))
    },
    profitClass (a, b) {
      return this.toNumber(a) - this.toNumber(b) < 0 ? 'fc-blue' : 'fc-red'
    },
    formatData (betData) {
      if (!betData) return ''
      const text = String(betData)
      const idx = text.indexOf('[')
      if (idx >= 0) {
        const vendorNm = text.substring(0, idx).trim()
        const gameNm = text.substring(idx).trim()
        return `${vendorNm}<span>${gameNm}</span>`
      }
      return text
    },
    normalizeTopUserList (list) {
      if (!Array.isArray(list)) return []

      const seen = new Set()
      return list.filter(item => {
        const key = item && item.recommenderId
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    async loadTopUserList (item) {
      const memId = item && item.memId
      if (!memId || item.topUserListLoading || item.topUserListLoaded) return

      item.topUserListLoading = true
      try {
        console.log('memId', memId)
        const res = await getTopUserListV2({ memId })
        console.log('res', res)
        const result = res.data || {}
        const topUserList = result.data && result.data.topUserList

        if (result.resultCode === '0') {
          const normalizedList = this.normalizeTopUserList(topUserList)
          console.log('normalizedList', normalizedList)
          item.topUserList = normalizedList.slice(0, 2)
          item.topUserListLoaded = true
        }
      } catch (e) {
        console.error(e)
      } finally {
        item.topUserListLoading = false
      }
    },
    dataConverter (data) {
      if (!data) return {}
      if (data.loginDt) {
        data.loginDt = replaceDateT(data.loginDt)
      }
      if (!Array.isArray(data.topUserList) && data.recommenderId) {
        data.topUserList = [{
          recommenderId: data.recommenderId,
          partnerLevelName: data.recommenderLevelName
        }]
      }
      data.topUserList = this.normalizeTopUserList(data.topUserList)
      return data
    },
    async loadSubList (memId, type, page) {
      const targetPage = page || (this.pageInfo && this.pageInfo.page) || 1
      this.pageInfo.page = targetPage

      this.setLoading(true)
      const params = {
        memId: this.searchValue.trim(),
        startDate: this.dateOnly(this.startDate),
        endDate: this.dateOnly(this.endDate)
      }

      try {
        console.log('params', params)
        const res = await getUserOnlineListV2(params, type)
        console.log('res', res)
        const resultData = res.data || {}

        console.log('resultData', resultData)

        if (resultData.resultCode === '0') {
          const list = Array.isArray(resultData.data.list) ? resultData.data.list : []
          this.userList = list.map(row => {
            const item = this.dataConverter({ ...row })
            return item
          })
        } else {
          this.userList = []
        }

        const apiPageInfo = resultData.pageInfo || {}
        this.pageInfo = {
          page: targetPage,
          count_per_list: apiPageInfo.count_per_list || 40,
          tatal_list_count: this.userList.length
        }
      } catch (e) {
        console.error(e)
        this.userList = []
        this.pageInfo = {
          page: 1,
          count_per_list: 40,
          tatal_list_count: 0
        }
      } finally {
        this.setLoading(false)
      }
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style src="@/styles/pt.css"></style>
<style scoped>
.online-white-ui {
  max-width: none;
  width: 100%;
  min-width: 1200px;
  margin: 0;
  padding: 0 18px 40px;
  overflow: visible;
  box-sizing: border-box;
  background: #f4f7fb;
  color: #172033;
}

.page-title-row {
  margin: 8px 0 18px;
}

.page-title-row h3 {
  font-size: 17px;
  font-weight: 900;
  color: #172033;
}

.page-title-row span {
  margin: 0 6px;
  color: #718096;
}

.searchwrap.online-searchwrap {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 70px 18px 18px;
  margin-bottom: 22px;
  border: 1px solid #d8e2ef;
  border-radius: 4px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
}

.search-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.search-line {
  display: flex;
  align-items: flex-end;
  gap: 28px;
  flex-wrap: wrap;
}

.search-group {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.search-group label {
  width: 70px;
  color: #1f2937;
  font-size: 13px;
  font-weight: 900;
  white-space: nowrap;
}

.search-group input,
.search-group select {
  height: 32px !important;
  min-width: 126px !important;
  padding: 0 12px !important;
  border: 1px solid #cfd8e5 !important;
  border-radius: 4px !important;
  background: #f8fafc !important;
  color: #263447 !important;
  font-size: 13px !important;
  box-sizing: border-box;
}

.category-group input {
  width: 170px;
}

.date-wave {
  color: #536074;
  font-weight: 800;
}

.quick-btn,
.btn-search {
  height: 32px;
  padding: 0 12px;
  border: 1px solid #cfd8e5;
  border-radius: 4px;
  background: #ffffff;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.quick-btn.active,
.btn-search {
  border-color: #2f80ed;
  background: #2f80ed;
  color: #ffffff;
}

.sort-group select {
  min-width: 180px !important;
}

.memo-button {
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cfd8e5;
  border-radius: 4px;
  background: #f8fafc;
  color: #334155;
  font-size: 25px;
  cursor: pointer;
}

.main-contents-wrapper {
  background: transparent;
}

.total-info-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.total-info-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #172033;
  font-size: 13px;
  font-weight: 800;
}

.total-info-item .value {
  color: #e11d48;
}

.online-content-grid {
  display: grid;
  /* grid-template-columns: minmax(360px, 48%) minmax(620px, 1fr); */
  gap: 20px;
  align-items: start;
}

.partner-tree-card,
.online-table-card {
  min-height: 0;
  border: 1px solid #e1e8f2;
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  overflow: hidden;
}

.tree-card-head {
  height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf2f7;
  color: #172033;
  font-size: 14px;
  box-sizing: border-box;
}

.tree-card-body {
  padding: 14px;
  box-sizing: border-box;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #2d3748;
  font-size: 12px;
  cursor: pointer;
}

.toggle-label input {
  display: none;
}

.toggle-label i {
  position: relative;
  width: 34px;
  height: 18px;
  border-radius: 999px;
  background: #d9dee8;
}

.toggle-label i::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0,0,0,.25);
  transition: 0.2s;
}

.toggle-label input:checked + i {
  background: #22c55e;
}

.toggle-label input:checked + i::after {
  left: 18px;
}

.online-table-card {
  overflow-x: auto;
}

.online-table-card::-webkit-scrollbar {
  height: 8px;
}

.online-table-card::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #aab4c2;
}

.mainTable.online-main-table {
  width: 100%;
  min-width: 1480px;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: center;
  font-size: 13px;
}

.mainTable th {
  height: 48px;
  padding: 8px 6px;
  border-bottom: 1px solid #d9e2ee;
  background: #eef3fa;
  color: #172033;
  font-weight: 900;
  line-height: 1.35;
  vertical-align: middle;
  white-space: normal;
  word-break: keep-all;
}

.mainTable td {
  height: 54px;
  padding: 8px 6px;
  border-bottom: 1px solid #edf2f7;
  color: #172033;
  vertical-align: middle;
  line-height: 1.35;
  word-break: keep-all;
}

.mainTable tbody tr:hover td {
  background: #f8fbff;
}

.empty-cell {
  height: 70px !important;
  color: #5f6b7a !important;
  text-align: center;
}

.id-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.btn-link {
  border: 0;
  background: transparent;
  cursor: pointer;
}

.fc-id {
  color: #2563eb;
  font-weight: 900;
}

.fc-nick .box {
  display: inline-flex;
  min-width: 72px;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 3px;
  background: #8376d4;
  color: #ffffff;
  font-size: 12px;
}

.topwrap {
  position: relative;
  width: 118px;
  margin: 0 auto;
}

.topwrap select {
  width: 100%;
  height: 26px !important;
  padding: 0 20px 0 6px !important;
  border: 1px solid #cfd8e5 !important;
  border-radius: 3px !important;
  background: #ffffff !important;
  font-size: 11px !important;
}

.topwrap .icon {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #334155;
  font-size: 11px;
  pointer-events: none;
}

.strong-money {
  color: #111827;
  font-weight: 900;
}

.ipwrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ipwrap .ip {
  color: #f97316;
  font-weight: 900;
  word-break: break-all;
  overflow-wrap: anywhere;
}

.money {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0;
  margin: 0;
}

.money li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.money em {
  color: #334155;
  font-size: 12px;
  text-align: left;
}

.money span {
  color: #111827;
  font-weight: 800;
  text-align: right;
}

.fc-red {
  color: #2563eb !important;
  font-weight: 900;
}

.fc-blue {
  color: #e11d48 !important;
  font-weight: 900;
}

.recent-game {
  display: flex;
  flex-direction: column;
  gap: 4px;
  word-break: break-all;
}

.recent-game span {
  color: #64748b;
}

.status-change-btn-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-inout {
  min-width: 48px;
  height: 34px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: #5068d4;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.15;
  cursor: pointer;
}

button.btn-inout {
  border: 0;
}

.btn-inout.bg-rd {
  background: #e11d48;
}

.partnerPaging {
  margin-top: 18px;
}

/* table alignment fix */
.mainTable.online-main-table {
  min-width: 1480px;
}

.mainTable.online-main-table th,
.mainTable.online-main-table td {
  text-align: center;
  vertical-align: middle;
}

.mainTable.online-main-table th {
  height: 46px;
  padding: 7px 6px;
}

.mainTable.online-main-table td {
  height: 58px;
  padding: 7px 6px;
}

.id-cell {
  width: 100%;
  min-height: 44px;
  justify-content: center;
}

.id-cell .btn-link {
  min-height: 18px;
  line-height: 18px;
  padding: 0;
}

.fc-nick .box {
  /* max-width: 92px; */
  min-width: 0;
  height: 20px;
  padding: 0 7px;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
  width: auto;
}

.topwrap {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ipwrap,
.money,
.recent-game,
.status-change-btn-wrap {
  min-height: 44px;
  justify-content: center;
}

.money li {
  min-height: 18px;
}

.status-change-btn-wrap .btn-inout {
  margin: 0 auto;
}

@media (max-width: 1500px) {
  .online-content-grid {
    grid-template-columns: 1fr;
  }

  .partner-tree-card {
    min-height: 260px;
  }
}

/* responsive white UI fix */
:global(body) {
  min-width: 320px !important;
}

:global(#PTpage),
:global(#PTbodyWrap),
:global(.PTboardwrap) {
  min-width: 0 !important;
}

.online-white-ui {
  min-width: 0;
}

@media (max-width: 1400px) {
  .online-white-ui {
    padding: 0 14px 34px;
  }

  .searchwrap.online-searchwrap {
    padding: 16px 62px 16px 16px;
  }

  .search-line {
    gap: 14px;
  }

  .date-group {
    flex: 1 1 620px;
  }

  .sort-group {
    flex: 0 1 320px;
  }

  .category-group {
    flex: 1 1 520px;
  }

  .mainTable.online-main-table {
    min-width: 1320px;
  }
}

@media (max-width: 1092px) {
  .online-white-ui {
    width: 100%;
    padding: 0 12px 30px;
  }

  .page-title-row {
    margin: 12px 0 14px;
  }

  .page-title-row h3 {
    font-size: 16px;
  }

  .searchwrap.online-searchwrap {
    display: block;
    padding: 14px;
    margin-bottom: 16px;
  }

  .search-main {
    gap: 12px;
  }

  .search-line {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .search-group {
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;
  }

  .search-group label {
    width: 74px;
    min-width: 74px;
  }

  .date-group input[type="date"] {
    flex: 1 1 155px;
    min-width: 155px !important;
  }

  .quick-btn {
    flex: 1 1 calc(20% - 7px);
    min-width: 72px;
    padding: 0 6px;
  }

  .sort-group select {
    flex: 1 1 250px;
    min-width: 180px !important;
  }

  .category-group select {
    flex: 0 0 120px;
    min-width: 120px !important;
  }

  .category-group input {
    flex: 1 1 190px;
    width: auto;
    min-width: 160px !important;
  }

  .memo-button {
    position: static;
    transform: none;
    width: 100%;
    height: 38px;
    margin-top: 12px;
    font-size: 19px;
  }

  .total-info-container {
    margin-bottom: 8px;
  }

  .total-info-wrap {
    width: 100%;
    justify-content: flex-end;
    font-size: 12px;
  }

  .online-table-card {
    border-radius: 4px;
  }

  .mainTable.online-main-table {
    min-width: 1180px;
    font-size: 12px;
  }

  .mainTable.online-main-table th {
    height: 42px;
    padding: 6px 5px;
  }

  .mainTable.online-main-table td {
    height: 54px;
    padding: 6px 5px;
  }
}

@media (max-width: 768px) {
  .online-white-ui {
    padding: 0 10px 26px;
    background: #f4f7fb;
  }

  .searchwrap.online-searchwrap {
    padding: 12px;
    border-radius: 8px;
  }

  .search-group {
    align-items: flex-start;
  }

  .search-group label {
    width: 100%;
    min-width: 100%;
    margin-bottom: 2px;
  }

  .date-group input[type="date"] {
    flex: 1 1 calc(50% - 12px);
    min-width: 0 !important;
  }

  .date-wave {
    width: 14px;
    text-align: center;
    line-height: 32px;
  }

  .quick-btn {
    flex: 1 1 calc(33.333% - 7px);
    min-width: 0;
    font-size: 12px;
  }

  .sort-group select,
  .category-group select,
  .category-group input {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0 !important;
  }

  .btn-search {
    width: 100%;
  }

  .total-info-container {
    justify-content: flex-start;
  }

  .total-info-wrap {
    justify-content: space-between;
  }

  /* 모바일에서도 PC 테이블 구조를 유지하고 좌우 스크롤로 확인 */
  .online-content-grid {
    display: block;
  }

  .online-table-card {
    position: relative;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    border: 1px solid #e1e8f2;
    border-radius: 5px;
    background: #ffffff;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
    scrollbar-width: thin;
    scrollbar-color: #aab4c2 #edf2f7;
  }

  .online-table-card::-webkit-scrollbar {
    display: block;
    height: 8px;
  }

  .online-table-card::-webkit-scrollbar-track {
    background: #edf2f7;
  }

  .online-table-card::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #aab4c2;
  }

  .mainTable.online-main-table {
    display: table;
    width: 1480px;
    min-width: 1480px;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 12px;
  }

  .mainTable.online-main-table colgroup {
    display: table-column-group;
  }

  .mainTable.online-main-table thead {
    display: table-header-group;
  }

  .mainTable.online-main-table tbody {
    display: table-row-group;
  }

  .mainTable.online-main-table tr {
    display: table-row;
  }

  .mainTable.online-main-table th,
  .mainTable.online-main-table td {
    display: table-cell;
    width: auto;
    min-width: 0;
    box-sizing: border-box;
    text-align: center;
    vertical-align: middle;
  }

  .mainTable.online-main-table th {
    height: 42px;
    padding: 6px 5px;
  }

  .mainTable.online-main-table td {
    height: 54px;
    min-height: 0;
    padding: 6px 5px;
    border-bottom: 1px solid #edf2f7;
    word-break: keep-all;
  }

  /* 기존 카드형 라벨 제거 */
  .mainTable.online-main-table td::before {
    display: none !important;
    content: none !important;
  }

  .mainTable.online-main-table tbody tr {
    margin: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    overflow: visible;
  }

  .mainTable.online-main-table tbody tr:hover td {
    background: #f8fbff;
  }

  .id-cell,
  .topwrap,
  .ipwrap,
  .money,
  .recent-game,
  .status-change-btn-wrap {
    min-height: 44px;
  }

  .topwrap {
    width: 118px;
    margin: 0 auto;
  }

  .money li {
    justify-content: space-between;
  }

  .recent-game {
    text-align: center;
  }

  .btn-inout {
    min-width: 48px;
    height: 34px;
  }

  .partnerPaging {
    margin-top: 12px;
  }
}

@media (max-width: 480px) {
  .page-title-row h3 {
    font-size: 15px;
  }

  .date-group input[type="date"] {
    flex: 1 1 100%;
  }

  .date-wave {
    display: none;
  }

  .quick-btn {
    flex: 1 1 calc(50% - 7px);
  }

  .online-table-card {
    border-radius: 4px;
  }

  .mainTable.online-main-table {
    min-width: 1480px;
  }
}
</style>
